import { render, staticRenderFns } from "./ExpertPage.vue?vue&type=template&id=e22cb3ae&lang=pug&"
import script from "./ExpertPage.vue?vue&type=script&lang=js&"
export * from "./ExpertPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports